import * as R from 'ramda'
import { BASE_SITE_URL } from 'sidecar-utility-library'

/**
 * Used in infinite scrolling situations where at the start the `page` is "null"
 * and so page 0 should be requested and then should just be incremented from
 * it's current value.
 *
 * @param {number | null} page The current page number, or null for first page
 * @returns A function that can be called with a number or null
 */
export const getCurrentPage = R.cond([
  [R.isNil, () => 0],
  [R.T, R.inc],
])

export const getFullCustomUrl = (altText, urlSlug = '') => {
  const slug = R.ifElse(
    R.isEmpty,
    () => altText,
    R.identity,
  )(urlSlug.replace(' ', ''))
  return [BASE_SITE_URL, 'for', slug].join('/')
}

export const getShortCustomUrl = (altText, urlSlug = '') => {
  return '/' + (urlSlug.replace(' ', '') || altText)
}

/*

queryParams come in as '?keyword=lucy&expenseUuids=dfa&doctorNpi=23432'
parameter could be "keyword" and the replacement value could be a new entry or 
null, meaning it is removed

the outcome is meant to be 'keyword=new&expenseUuids=dfa&doctorNpi=23432' if the keyword is "new",
or expenseUuids=dfa&doctorNpi=23432' if the keyword is not given,

the user would be responsible for adding the leading ? if needed.
when doing props.navigate({search: NEW_SEARCH_PARAMS}),it is not 
prepended with "?"
*/

export const replaceQueryParameter = (
  queryParams,
  parameterKey,
  parameterValue,
) => {
  return R.pipe(
    // remove the initial ?
    R.replace('?', ''),
    // split up all the search parameters by &
    R.split('&'),
    // extract out all the key value pairs
    R.map(parameter => {
      const [key, value] = parameter.split('=')
      return {
        key,
        value,
      }
    }),
    // filter out the key you want to replace
    R.filter(({ key }) => key !== parameterKey),
    // add the new value for the parameter you want to
    R.append({ key: parameterKey, value: parameterValue }),
    // remove any keys that do not have a non-nil value
    R.filter(({ value }) => !R.isNil(value)),
    // join up all the key/value pairs again
    R.map(({ key, value }) => `${key}=${value}`),
    // join all the searchParameters to reconstruct search parameters for url
    R.join('&'),
  )(queryParams)
}

export const removeQueryParameter = (queryParams, parameterToBeRemoved) => {
  // reusing logic from replace query parameter
  return replaceQueryParameter(queryParams, parameterToBeRemoved, null)
}
